<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>论文盲审结果</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>学号：</p>
                    <a-input class="input" v-model="info.studentNo" disabled />
                </div>
                <div class="input-box">
                    <p>姓名：</p>
                    <a-input class="input" v-model="info.studentName" disabled />
                </div>
                <div class="input-box">
                    <p>院系编号：</p>
                    <a-input class="input" v-model="info.orgCode" disabled />
                </div>
                <div class="input-box">
                    <p>院系：</p>
                    <a-input class="input" v-model="info.orgName" disabled />
                </div>
                <div class="input-box">
                    <p>层次：</p>
                    <a-input class="input" v-model="info.level" disabled />
                </div>
                <div class="input-box">
                    <p>导师编号：</p>
                    <a-input class="input" :value="info.teacherId" disabled />
                </div>
                <div class="input-box">
                    <p>导师姓名：</p>
                    <a-input class="input" v-model="info.teacherName" disabled />
                </div>
                <div class="input-box">
                    <p>一级学科/专业学位类别：</p>
                    <a-input class="input" v-model="info.firstLevel" disabled />
                </div>
                <div class="input-box">
                    <p>二级学科/专业学位领域：</p>
                    <a-input class="input" v-model="info.secondLevel" disabled />
                </div>
                <div class="input-box">
                    <p>撰写论文语言：</p>
                    <a-input class="input" v-model="info.paperLanguage" disabled />
                </div>
                <div class="input-box input-box-center">
                    <p>论文题目：</p>
                    <a-input class="input" v-model="info.paperTitle" disabled/>
                </div>
                <div class="input-box">
                    <p>论文形式：</p>
                    <a-input class="input" v-model="info.paperForm" disabled/>
                </div>
                <div class="input-box input-box-center">
                    <p>课题名称：</p>
                    <a-input class="input" v-model="info.topicName" disabled/>
                </div>
                <div class="input-box">
                    <p>盲审类别：</p>
                    <a-input class="input" :value="info.blindReviewCategory" disabled/>
                </div>
                <div class="input-box">
                    <p>论文类别：</p>
                    <a-input class="input" v-model="info.paperType" disabled/>
                </div>
                <div class="input-box">
                    <p>送审份数：</p>
                    <a-input class="input" v-model="info.cnt" disabled/>
                </div>
                <div class="input-box">
                    <p>送审状态：</p>
                    <a-input class="input" v-model="info.submissionStatus" disabled/>
                </div>
                <div class="input-box">
                    <p>双盲状态：</p>
                    <a-input class="input" v-model="info.doubleBlindState" disabled/>
                </div>
                <div class="input-box">
                    <p>双盲结果：</p>
                    <a-input class="input" v-model="info.doubleBlindResult" disabled/>
                </div>
                <div class="input-box">
                    <p>学院审核时间：</p>
                    <a-input class="input" :value="info.collegeAuditDate" disabled/>
                </div>
                <div class="input-box">
                    <p>总评分1：</p>
                    <a-input class="input" :value="info.score1" disabled/>
                </div>
                <div class="input-box">
                    <p>评议结果1：</p>
                    <a-input class="input" :value="info.result1" disabled/>
                </div>
                <div class="input-box">
                    <p>选题1：</p>
                    <a-input class="input" v-model="info.xt1" disabled/>
                </div>
                <div class="input-box">
                    <p>创新1：</p>
                    <a-input class="input" v-model="info.cx1" disabled/>
                </div>
                <div class="input-box">
                    <p>学术1：</p>
                    <a-input class="input" v-model="info.xs1" disabled/>
                </div>
                <div class="input-box">
                    <p>应用1：</p>
                    <a-input class="input" v-model="info.yy1" disabled/>
                </div>
                <div class="input-box">
                    <p>提炼1：</p>
                    <a-input class="input" v-model="info.tn1" disabled/>
                </div>
                <div class="input-box">
                    <p>评阅时间1：</p>
                    <a-input class="input" v-model="info.date1" disabled/>
                </div>
                <div class="input-box">
                    <p>总评分2：</p>
                    <a-input class="input" v-model="info.score2" disabled/>
                </div>
                <div class="input-box">
                    <p>评议结果2：</p>
                    <a-input class="input" v-model="info.result2" disabled/>
                </div>
                <div class="input-box">
                    <p>选题2：</p>
                    <a-input class="input" v-model="info.xt2" disabled/>
                </div>
                <div class="input-box">
                    <p>创新2：</p>
                    <a-input class="input" v-model="info.cx2" disabled/>
                </div>
                <div class="input-box">
                    <p>学术2：</p>
                    <a-input class="input" v-model="info.xs2" disabled/>
                </div>
                <div class="input-box">
                    <p>应用2：</p>
                    <a-input class="input" v-model="info.yy2" disabled/>
                </div>
                <div class="input-box">
                    <p>提炼2：</p>
                    <a-input class="input" v-model="info.tn2" disabled/>
                </div>
                <div class="input-box">
                    <p>评阅时间2：</p>
                    <a-input class="input" v-model="info.date2" disabled/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { info } from '@/baseAPI/master/concealedEvaluation'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                info:{},
                year:'',
                permissions:[],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.year=getSchoolYear()+''
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)

            info(this.$route.query.id).then(res=>{
                this.info=res.data;
            })
            

        },
        methods:{

        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 66%;
    }

    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .answer-input{
        width: calc(100% - 10rem);
        border-color:red;
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .action-btn{
        background-color: #1890ff;
        color: #fff;
        line-height: 32px;
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
    }
</style>
